import type {Profile,Document,FinancialYear,ReferenceBlock,Relationship,ActivityRecord,DashboardSummary,DocumentFilter,StagedDocument,DuplicateCheckResult,DocumentVersion,SearchResult,User} from '../types/vault';

export interface VaultRepository {
  providerName: string;
  // Auth
  login(email: string, password: string): Promise<void>;
  logout(): void;
  getCurrentUser(): User | null;
  checkAuth(): Promise<boolean>;
  requestPasswordReset(email: string): Promise<void>;
  confirmPasswordReset(token: string, password: string, passwordConfirm: string): Promise<void>;
  confirmVerification(token: string): Promise<void>;
  confirmEmailChange(token: string, password: string): Promise<void>;
  
  // Data
  listProfiles(): Promise<Profile[]>;
  getProfile(id: string): Promise<Profile | null>;
  saveProfile(profile: Profile): Promise<Profile>;
  
  listReferenceBlocks(profileId: string): Promise<ReferenceBlock[]>;
  listAllReferenceBlocks(): Promise<ReferenceBlock[]>;
  saveReferenceBlock(block: ReferenceBlock): Promise<ReferenceBlock>;
  
  listFinancialYears(profileId?: string): Promise<FinancialYear[]>;
  getFinancialYear(id: string): Promise<FinancialYear | null>;
  saveFinancialYear(year: FinancialYear): Promise<FinancialYear>;
  
  listDocuments(filters?: DocumentFilter): Promise<Document[]>;
  getDocument(id: string): Promise<Document | null>;
  saveDocumentMetadata(doc: Document): Promise<Document>;
  updateDocumentMetadata(documentId: string, updates: Partial<Document>): Promise<Document>;
  renameDocument(documentId: string, newTitle: string): Promise<Document>;
  archiveDocument(documentId: string): Promise<Document>;
  restoreDocument(documentId: string): Promise<Document>;
  permanentlyDeleteDocument(documentId: string): Promise<void>;
  
  stageDocuments(files: File[]): Promise<StagedDocument[]>;
  uploadDocuments(batch: StagedDocument[]): Promise<StagedDocument[]>;
  getDocumentBlob(documentId: string, versionId?: string): Promise<Blob | null>;
  downloadDocument(documentId: string, versionId?: string): Promise<{blob: Blob; filename: string}>;
  checkDocumentDuplicates(item: StagedDocument): Promise<DuplicateCheckResult>;
  
  listDocumentVersions(documentId: string): Promise<DocumentVersion[]>;
  listAllDocumentVersions(): Promise<DocumentVersion[]>;
  addDocumentVersion(documentId: string, file: File, reason?: string): Promise<DocumentVersion>;
  
  listRelationships(profileId: string): Promise<Relationship[]>;
  listAllRelationships(): Promise<Relationship[]>;
  
  listActivityRecords(profileId?: string): Promise<ActivityRecord[]>;
  getDashboardSummary(): Promise<DashboardSummary>;
  searchVault(query: string): Promise<SearchResult[]>;
}

let instance: VaultRepository | null = null;

export function getRepository(): VaultRepository {
  if (!instance) throw new Error('VaultRepository has not been initialized.');
  return instance;
}

export function setRepository(repository: VaultRepository): void {
  instance = repository;
}